// UserBbsInfoDict.js
import IsValid from "../../../value/IsValid";
import { AppPalette, InputType, TableColumnType } from "../../../value/AppConst";

export function makeUserBbsCatOptions(list) {
    return list.map((code)=>{
        return {
            userBbsCatCd: code.codeId,
            label: code.codeName,
        }
    });
}

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    custId : {toAdd: true, toEdit: true},
    
    bbsInfoSeq : {
        id: 'bbsInfoSeq', required: true, toAdd: false, toEdit: true,
    },
    email : {
        id: 'email', label: 'E-mail', type: InputType.email, required: false,
        toAdd: true, toEdit: true,
        min:0, max:60,
        errorHelp: '60자 이내로 입력하세요.',
        check: (value) => IsValid.emailNullable(value, 60),
    },
    userBbsCatCd : {
        id: 'userBbsCatCd', label: '게시물 분류', type: InputType.select, required: true,
        toAdd: true, toEdit: true,
        default: 'question'
    },
    /* userBbsStatusCd : {
        id: 'userBbsStatusCd', label: '진행상태', type: InputType.select, required: false,
        toAdd: true, toEdit: true,
    }, */
    title : {
        id: 'title', label: '제목', type: InputType.text, required: true,
        toAdd: true, toEdit: true,
        help: '70자 이내로 입력하세요.',
        min: 1, max: 200,
        check: (value) => IsValid.string(value, 1, 200),
    },
    content : {
        id: 'content', label: '내용', type: InputType.text, required: true,
        toAdd: true, toEdit: true,
        help: '2000자 이내로 입력하세요.',
        min: 5, max: 3000,
        rows: 8,
        check: (value) => IsValid.string(value, 5, 6000),
    },
    markup : {
        id: 'markup', label: '마크업 사용', type: InputType.checkbox, required: true,
        toAdd: true, toEdit: true, default: false,
    },
    topOrder : {
        id: 'topOrder', label: '맨 위에 표시', type: InputType.checkbox, required: true,
        toAdd: true, toEdit: true,
        default: false, // 관리자만 가능한 기능.
    },
};

function printFileName(row) {
    // check how many files are attached
    const fileNames = [];
    for(let i=1; i<=5; i++) {
        const key = 'fileName' + i;
        if(row[key]) fileNames.push(row[key]);
    }
    // return first name and count-1 (xxx 외 n개)
    if(fileNames.length === 0) return '';
    else return fileNames[0] + (fileNames.length > 1 ? ' 외 ' + (fileNames.length-1) + '개' : '');
}

export const UserBbsInfoDict = {
    inputMap: Dict,
    errorTitle: {
        Add: '게시물 생성 오류',
        Edit: '게시물 수정 오류',
        Remove: '게시물 삭제 오류',
        Get: '게시물 조회 오류',
    },
    tableProps: {
        tableId: 'userBbsInfoTable',
        uniqueKey: 'bbsInfoSeq',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
        },
        columns: [
            //{ id: 'bbsInfoSeq', label: Dict.bbsInfoSeq.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.INTEGER} },
            { id: 'userBbsCat', label: Dict.userBbsCatCd.label, width: 50, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
            {
                id: 'userBbsStatus', label: '진행상태', width: 50, show: true,
                option:{
                    align: 'center', // type: TableColumnType.TEXT,
                    print: (r,i,v) => {
                        if(r.userBbsStatusCd==='wait')
                            return <span style={{color:AppPalette.WarnRGB}}>{v}</span>;
                        else if(r.userBbsStatusCd==='testing')
                            return <span style={{color:AppPalette.SecondaryRGB}}>{v}</span>;
                        else return <span>{v}</span>;
                    }
                }
            },
            { id: 'dscName', label: '소속', width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            { id: 'title', label: Dict.title.label, width: 180, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'email', label: Dict.email.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            { id: 'readCnt', label: '조회수', width: 50, show: true, option:{align: 'right', type: TableColumnType.INTEGER} },
            { id: 'file', label: '첨부파일', width: 120, show: true, option:{align: 'inherit', print: (r,i,v) => {return printFileName(r)}} },
            // { id: 'regTime', label: Dict.regTime.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.DATETIME} },
            { id: 'regUserName', label: '등록자', width: 80, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            { id: 'updateTime', label: '최종수정', width: 120, show: true, option:{align: 'inherit', type: TableColumnType.DATETIME} }
        ]
    }
}